export const placesEat = [
  {
    name: "Oxbow Public Market",
    body: "A local gathering place for great food and wine in downtown Napa. Hog Island Oysters is a favorite!",
    url: "oxbowpublicmarket.com"
  },
  {
    name: "The Marshall Store",
    body: "Fresh oysters served on the shore. While they can’t legally serve you the wine and beer for sale in the general store, they keep bottle openers on the counter. Amanda would eat here every day if she could.",
    url: "themarshallstore.com"
  },
  {
    name: "El Molino Central",
    body: "A Mexican gem recommended by Tracy and Chester. Order inside the tiny storefront and head around back to eat at the picnic tables.",
    url: "elmolinocentral.com"
  },
  {
    name: "La Foret Chocolates",
    body: "These are the large and fabulous boxes of chocolates Amanda always seems to be carrying back for Janice. In case you don’t have that much room in your carry on, rest assured that they do sell assortments smaller than a hatbox...",
    url: "laforetchocolate.com"
  },
  {
    name: "Ad Hoc",
    body: "Thomas Keller’s casual, American comfort food venue. The Daily-changing four-course menu is served family-style. We recommend the supplements and the wine pairings.",
    url: "thomaskeller.com/adhoc"
  },
  {
    name: "Addendum",
    body: "Thomas Keller’s take on boxed to-go lunches. Choose between buttermilk fried chicken, barbecued pork ribs, or a pulled pork sandwich and sides.",
    url: "thomaskeller.com/addendum"
  },
  {
    name: "Boonfly Cafe",
    body: "Even Calvin and Amanda (who don’t typically eat sweets) like the doughnuts! Recommended for brunch or lunch.",
    url: "boonflycafe.com"
  },
  {
    name: "Cowgirl Creamery",
    body: "Cheeses, breads, wines, and prepared foods. Cheese 101 classes and tastings are available on Thursdays and Fridays.",
    url: "cowgirlcreamery.com/pt-reyes-shop-creamery"
  },
  {
    name: "Cindy’s Backstreet Kitchen",
    body: "Home of the famous campfire pie!",
    url: "cindysbackstreetkitchen.com"
  }
]


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/thingsToDo/placesEat.ts